module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-progressbar"
  }, [_c('p', [_vm._v("Krok " + _vm._s(_vm.current) + " z " + _vm._s(_vm.max))]), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, _vm._l((_vm.max), function(step) {
    return _c('span', {
      class: {
        'progressbar-item': true, 'step-ok': step < _vm.current, 'step-current': step == _vm.current, 'step-no': step > _vm.current
      }
    }, [(step <= _vm.current) ? _c('router-link', {
      attrs: {
        "to": {
          name: _vm.stepsUrl[step - 1]
        }
      }
    }) : _vm._e()], 1)
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-97eb2560","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProgressBar.vue
// module id = 579
// module chunks = 1